import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/shared/Modal';
import SelectFacebookTokenType from 'components/modals/newSocialMediaProfile/SelectFacebookTokenType';
import { SocialLoginTokenType } from 'types/SocialLogin';

interface MetaTokenTypeModalProps {
  open: boolean;
  onClose: () => void;
  onSelectTokenType: (tokenType: SocialLoginTokenType) => void;
}

const MetaTokenTypeModal = ({
  open,
  onClose,
  onSelectTokenType,
}: MetaTokenTypeModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="responsive"
      classNames={{ modal: '!tw-max-w-[480px]' }}
      dataName={{
        wrapper: 'social-login_token-type-modal',
        closeButton: 'social-login_token-type-modal_close-icon',
      }}
    >
      <Modal.Header title={t('newSocialMediaProfile.methodCards.title')} />
      <Modal.Content className="tw-pb-6">
        <SelectFacebookTokenType
          onSelectPersonal={() => onSelectTokenType('user')}
          onSelectObo={() => onSelectTokenType('system_user_obo')}
        />
      </Modal.Content>
    </Modal>
  );
};

export default MetaTokenTypeModal;
